import { render, staticRenderFns } from "./upl.vue?vue&type=template&id=c42cd79a&scoped=true&"
import script from "./upl.vue?vue&type=script&lang=js&"
export * from "./upl.vue?vue&type=script&lang=js&"
import style0 from "./upl.vue?vue&type=style&index=0&id=c42cd79a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c42cd79a",
  null
  
)

export default component.exports